import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('svg', {
    staticClass: "v-circular-loader",
    style: _vm.styles,
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "v-circular-loader__path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none",
      "stroke-width": _vm.thickness
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-8c5058f6_0", {
    source: ".v-circular-loader[data-v-8c5058f6]{animation:rotate-data-v-8c5058f6 2s linear infinite;transform-origin:center center;display:inline-block;flex-shrink:0;width:1em;height:1em;font-size:var(--c-size);color:var(--c-color)}@keyframes rotate-data-v-8c5058f6{100%{transform:rotate(360deg)}}.v-circular-loader__path[data-v-8c5058f6]{stroke-dasharray:150,200;stroke-dashoffset:-10;animation:dash-data-v-8c5058f6 1.5s ease-in-out infinite;stroke-linecap:round;stroke:currentColor}@keyframes dash-data-v-8c5058f6{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:89,200;stroke-dashoffset:-35}100%{stroke-dasharray:89,200;stroke-dashoffset:-124}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-8c5058f6";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var CircularLoader = __vue_component__;
export { CircularLoader as default };